import { useTranslations } from 'next-intl'
import { cn } from '@segway/core'

import { Button } from '@/ui'

import { Arrow, ButtonLoadingIcon } from '../icons'

interface ViewMoreProps {
  isShowMore: boolean | undefined
  current: number
  totals: number
  loading: boolean
  className?: string
  onViewMore: () => void
}

const ViewMore = ({
  isShowMore,
  current,
  totals,
  loading,
  className,
  onViewMore,
}: ViewMoreProps) => {
  const t = useTranslations('Common')

  return (
    <>
      {isShowMore && (
        <Button
          variant="secondary"
          type="button"
          disabled={loading}
          onClick={onViewMore}
          className={cn(
            'm-auto mb-6 flex w-max cursor-pointer items-center rounded-[101px] px-8 py-2 xl:py-3',
            className,
          )}>
          <span className="text-[13px] leading-[16px] xl:text-lg xl:leading-[20px]">
            {t('view_more', {
              current,
              totals,
            })}
          </span>
          <span className="inline-flex items-center justify-center">
            <Arrow rotate={90} color={loading ? '#00000014' : '#000000'} />
          </span>
          {loading && (
            <span className="ml-1 inline-flex items-center justify-center">
              <ButtonLoadingIcon />
            </span>
          )}
        </Button>
      )}
    </>
  )
}

export default ViewMore
